import * as Icons from "@nova/component-icons"

export const InspectorPanelHotspotsLayerFiltersNotEnoughData = () => {
    return (
        <div className="bg-black-400 border border-white-200 rounded-lg flex gap-2 p-2 items-center select-none">
            <Icons.SmallIcon Icon={Icons.Error} className="text-yellow-500" />
            <span className="text-gray-0">
                <small>Not enough data.</small>
                <br />
                <small>Please decrease sensitivity.</small>
            </span>
        </div>
    )
}
